import React from "react";
import {Navigate} from 'react-router-dom';
// import axios from 'axios';
import Menu from "../components/menu/Menu";
import ListGrupos from "../components/list-grupos/ListGrupos";
import {Container} from 'react-bootstrap';
import Verify from "../components/verify/Verify"
// import { trackPromise } from 'react-promise-tracker';

const ListGruposMain = () => {


    if(!sessionStorage.getItem('userData')){
        return <Navigate to="/"  />;
    }
    else{
        Verify()
    }
    
    return(
        <>
            <Menu />
            <Container>
                <ListGrupos />
            </Container>
        </>
    )
};

export default ListGruposMain;
